module.exports = __webpack_public_path__ + "img/oc_moon.a8f2060.avif";